const BottomWinter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none">
    {/* Background wave — stretches horizontally */}
    <svg
      viewBox="0 0 376 214"
      preserveAspectRatio="none"
      width="100%"
      height="100%"
    >
      <path
        d="M0.0147042 213.445L375.31 201.278V0C356.949 5.59066 340.03 16.0069 335.719 33.1908C319.889 14.8741 275.987 25.7317 283.446 63.5717C262.113 33.3233 210.194 46.6672 207.266 87.2142C206.001 57.3925 168.205 43.46 149.432 62.7625C148.108 26.482 90.4509 9.57765 65.2488 58.2016C68.3973 16.5218 29.2774 -5.66422 0 20.8473V213.431L0.0147042 213.445Z"
        fill="#8FAEF4"
      />
    </svg>

    {/* Foreground decorations — maintain aspect ratio, stay centered */}
    <svg
      viewBox="0 0 376 214"
      preserveAspectRatio="xMidYMin meet"
      width="100%"
      height="100%"
    >
      <path
        d="M336.44 36.4877C336.44 36.4877 346.003 10.6677 340.559 7.87238C335.116 5.09176 335.234 24.3354 335.234 24.3354C335.234 24.3354 333.659 16.0965 326.038 19.7305C318.403 23.3644 336.455 36.473 336.455 36.473L336.44 36.4877Z"
        fill="#8FAEF4"
      />
      <path
        d="M62.6896 65.5436C62.6896 65.5436 53.3914 18.8469 63.896 17.4198C74.4005 15.9927 67.5005 39.5177 67.5005 39.5177C67.5005 39.5177 73.6207 29.7781 80.3001 32.956C86.9648 36.1338 69.9133 66.4264 62.6896 65.5436Z"
        fill="#8FAEF4"
      />
      <path
        d="M203.426 92.0997C203.426 92.0997 204.117 50.979 215.975 49.2282C227.833 47.4628 206.707 94.4243 206.707 94.4243L203.426 92.0997Z"
        fill="#8FAEF4"
      />
      <path
        d="M214.284 99.132C214.284 99.132 190.921 65.2938 199.543 56.9667C208.164 48.6395 218.301 99.1173 218.301 99.1173H214.284V99.132Z"
        fill="#8FAEF4"
      />
    </svg>
  </svg>
)

export default BottomWinter
